import { stateOverrideConstants } from '../../constants/stateOverrideConstants';
import { IError, IStatesOverride } from '../../interfaces';


interface IStateOverrideState {
    refresh: number;
    stateOverride: IStatesOverride | null;
    comments?: [];
    errors: IError;
}

interface IStateOverrideAction {
    type: string;
    stateOverride: IStatesOverride;
    errors: IError;
    comments?: [];
}

/**
 * State selection reducer. Controls form state
 *
 * @param {Object} state Current application state
 * @param {Object} action Current action
 *
 * @return {Object}
 */
export function stateOverride(state: IStateOverrideState = {
    refresh: Date.now(),
    stateOverride: null,
    comments: [],
    errors: {},
}, action: IStateOverrideAction): IStateOverrideState {

    switch (action.type) {

        case stateOverrideConstants.UPDATE_SUCCESS:
        case stateOverrideConstants.STORE_SUCCESS:
        case stateOverrideConstants.COMMENTS_SUCCESS:

            return {
                refresh: Date.now(),
                stateOverride: action.stateOverride,
                errors: {},
                comments: action.comments,
            };

        case stateOverrideConstants.UPDATE_FAILURE:
        case stateOverrideConstants.STORE_FAILURE:
        case stateOverrideConstants.COMMENTS_FAILURE:

            return {
                refresh: Date.now(),
                stateOverride: null,
                comments: [],
                errors: action.errors,
            };


        default:

            return state;
    }
}
